<mat-card class="munily-frequent-access-card">
  <div class="munily-frequent-access-card__header">
    <h3 class="munily-frequent-access-card__title">{{ data.title }}</h3>
    <common-icon-button
      icon="more_vert"
      ariaLabel="acciones de acceso"
      size="small"
      (output)="onAction()"
    ></common-icon-button>
  </div>

  <div class="munily-frequent-access-card__meta">
    <div class="munily-frequent-access-card__row">
      <mat-icon class="material-icons-outlined munily-frequent-access-card__icon">badge</mat-icon>
      <span>{{ data.accessType }}</span>
    </div>
    <div class="munily-frequent-access-card__row">
      <mat-icon class="material-icons-outlined munily-frequent-access-card__icon">calendar_month</mat-icon>
      <span>{{ data.dateText }}</span>
    </div>
  </div>
</mat-card>
